import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';
import CheckboxButton from 'shared-components/buttons/checkbox-button';
import Button from '../../elements-buttons/Button';
import validateMessageOptions from './validation/validateMessageOptions';
import { Field, reduxForm } from 'redux-form';

class NotificationChoiceModalBase extends React.Component {
  constructor (props) {
    super(props);
    this.state= { analyticsCalled: false };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.messageChoiceOptions = this.messageChoiceOptions.bind(this);
  }

  componentDidUpdate () {
    if (!this.state.analyticsCalled) {
      const { whichModal = '' } = this.props;
      if (whichModal && whichModal !== 'NotificationChoiceModal') return;
      this.props.calendarSurveyAnalytics('reminder type');
      this.setState({ analyticsCalled: true });
    }
  }

  handleOptionChange ({ input, choice }, event) {
    const inputValue = input.value;
    const arr = [...inputValue];
    if (event.target.checked) {
      arr.push(choice);
    } else {
      arr.splice(arr.indexOf(choice), 1);
    }
    return input.onChange(arr);
  }

  messageChoiceOptions ({ input, options, meta }) {
    const { error, submitFailed, touched } = meta;
    const inputValue = input.value;
    const showError = !!((error && submitFailed) || (error && touched));
    const choices = Object.keys(options);
    const notificationChoices = choices.map((choice, idx) => {
      return (
        <CheckboxButton
          key={`${choice}${idx}`}
          text={options[choice]}
          value={choice}
          blockElement
          checked={inputValue.includes(choice)}
          classNames="margin-lg-bottom"
          rounded
          name={`${choice}`}
          onChange={(e) => this.handleOptionChange({ input, choice }, e)}
        />
      );
    });
    return (
      <div className="flex column margin-lg-bottom">
        {notificationChoices}
        {
          showError &&
          <div className="text-danger text-small">
            <FormattedMessage
              id="shared.select-an-option.error-text"
              defaultMessage="Please select at least one, or go back."
            />
          </div>
        }
      </div>
    );
  }

  onSubmit (values) {
    const { reminder_preference } = values;
    this.props.updateCalendarSyncReminder({ reminder_preference });
    this.props.toggleModal('SurveyCompleteModal');
  }

  render () {
    const { showModal, handleSubmit, toggleModal, host_survey_form: hostSurveyForms, intl } = this.props;
    const { reminder_preference } = hostSurveyForms;
    const messageOptions = {
      SMS: <FormattedMessage
        id="shared.sms_choice"
        defaultMessage="SMS"
      />,
      Email: <FormattedMessage
        id="shared.email_choice"
        defaultMessage="Email"
      />,
      Push: <FormattedMessage
        id="shared.push_notifications_choice"
        defaultMessage="Push Notifications"
      />
    };
    return (
      <BootstrapModal
        showModal={showModal}
        toggleModal={toggleModal}
        modalClass="host-survey-modal"
        goBack={() => toggleModal('ReminderModal')}
        headerClass="modal-header"
        header={
          <div>
            <h3 className="margin-xl-bottom">
              <FormattedMessage
                id="shared.notification_choice.header"
                defaultMessage="How would you like to receive your reminders?"
              />
            </h3>
          </div>
        }
        body={
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              options={messageOptions}
              name="reminder_preference"
              component={this.messageChoiceOptions}
            />
            <Button
              category="primary"
              className="btn-block"
              isLoading={false}
            >
              <FormattedMessage
                id='inbox.host_survey_modal.peerspace_other_calendar_cta'
                defaultMessage='Next'
              />
            </Button>
          </form>
        }
        bodyClass="sync-modal-body text-center"
      />
    );
  }
}

const config = {
  form: 'CALENDAR_CHOICES',
  validate: validateMessageOptions
};

export const NotificationChoiceModal = reduxForm(config)(NotificationChoiceModalBase);

NotificationChoiceModalBase.propTypes = {
  showModal: PropTypes.bool,
  updateSurveyState: PropTypes.func,
  changeModal: PropTypes.func,
  toggleModal: PropTypes.func,
  calendarSurveyAnalytics: PropTypes.func
};
